import { _,moment } from '../../vendor'
import InboomaBaseFilterableCollection from './InboomaBaseFilterableCollection';
import Reservation from '../models/Reservation';
import { Uri } from '../utils';

export default InboomaBaseFilterableCollection.extend({

    collectionName : 'reservationsList',
    model : Reservation,
    url : '/reservations?find=full',

    _filterParams: Uri.getUrlParameter('resource_id') ? {
        'resource_id': Uri.getUrlParameter('resource_id'),                 // default filter settings
        'finder': 'NotCancelled',
//        'sort' : 'begin',           // default sort
//        'direction' : 'asc'         // default sort direction
    } : {
        'begin_gte': moment().format('YYYY-MM-DD'),
        'finder': 'NotCancelled',
    },

    _inactiveFilterParams: {
    },

    _sorted : {}, // Only relevant for this collection
                  // We should've used native 
                  // this._pagination.sort / this._pagination.sortDirection

    _pagination : {
        current_page : 0,
        sort : 'begin',
        sortDirection : Uri.getUrlParameter('resource_id') ? 'desc' : 'asc',
        has_next_page : false,
        has_prev_page : false,
        count : 0, // not relevant; response total entities count
        limit : 40
    },

    /**
     * Central, reservationsList specific behavior to handle
     * complex filter-combinations.
     */
    setFilterAndSort (filterParam, optionValue, sort = null, sortDirection = null, filterName) {
console.log("Collection: setFilterAndSort: Param: " + filterParam + " option: " + optionValue + " sort: " + sort + " direction: " + sortDirection + " name: " + filterName);
        const that = this;

        this.url = '/reservations?find=full';

        // always set notcancelled finder
        //this._filterParams.finder = 'NotCancelled';

        // always set sort and sort direction
        this._filterParams.sort = sort;
        this._filterParams.sortDirection = sortDirection;
        this._filterParams.limit = this._pagination.limit;
        this._filterParams.page = 1;

        let cancelledFilter = false;

        _.each(this._filterParams, function(value, key) {
            if (key === 'status' && value === 'cancelled') {
                cancelledFilter = true;
            }
        });

        if (cancelledFilter !== true) {
            this._filterParams.finder = 'NotCancelled';
        }

        let dateFilter,
            dateValFilter = ['begin_gte', 'begin_lt', 'end_lt', 'begin_day', 'end_day'];
        
        if (dateValFilter.indexOf(filterParam) !== -1) {
            this._pagination.sortDirection = sortDirection;
            this._pagination.sort = sort;
            this._filterParams[filterParam] = optionValue;
            dateFilter = filterParam;
        } else if (filterParam == 'all') {
            sortDirection = this._pagination.sortDirection;
            sort = this._pagination.sort;
            delete this._filterParams.begin_gte;
            dateFilter = filterParam;
        } else {
            sortDirection = this._pagination.sortDirection;
            sort = this._pagination.sort;
            dateFilter = dateValFilter[dateValFilter.indexOf(filterParam)];
        }

        if (filterParam === 'begin_location') {
            this._filterParams.begin_location = optionValue;
        }
        if (filterParam === 'end_location') {
            this._filterParams.end_location = optionValue;
        }

        if (filterParam === 'status') {
            this._filterParams.status = optionValue;

            if (optionValue === 'reset') {
                delete this._filterParams.status;
            }

            if (optionValue === 'cancelled') {
                delete this._filterParams.finder;
            }
        }

        if (filterParam === 'contingent_id') {
            //delete this._filterParams.begin_gte;
            this._filterParams.contingent_id = optionValue;
        }

        // if (optionValue.includes(dateValFilter)) {
        //   this._filterParams.begin_gte = null;
        //   this._filterParams.begin_lt = null;
        //   this._filterParams.end_lt = null;
        //   this._filterParams.begin_day = null;
        //   this._filterParams.end_day = null;
        // }

        this._skipPagination = true;

        this._pagination.current_page = 0;

        this.fetchFirstPage(function() {
            delete that._skipPagination;
        }, true, sort, sortDirection);

    },

    removeFilterFromFilterParams(filterParam) {

      const that = this;
      const today = moment();

      this.url = '/reservations?find=full';

      delete this._filterParams[filterParam];

      var dateFilter;
      var cancelledFilter = false;
      var dateValFilter = ['begin_gte', 'begin_lt', 'end_lt', 'begin_day', 'end_day'];

      _.each(this._filterParams, function(value, key) {
        if(dateValFilter.indexOf(key) !== -1) {
            dateFilter = key;
          }
        if(key === 'status' && value === 'cancelled') {
          cancelledFilter = true;
        }
      });

      let sort, sortDirection;

      // if status changes always set NotCancelled
      if (cancelledFilter !== true) {
        this._filterParams.finder = 'NotCancelled';
      }

      if(dateFilter === 'begin_gte') {
        sort = 'begin';
        sortDirection = 'asc';
        this._pagination.sort = 'begin';
        this._pagination.sortDirection = 'asc';
      } else if (dateFilter === 'end_lt') {
        sort = 'end';
        sortDirection = 'desc';
        this._pagination.sort = 'end';
        this._pagination.sortDirection = 'desc';
      } else if (dateFilter === 'begin_day') {
        sort = 'begin';
        sortDirection = 'asc';
        this._pagination.sort = 'begin';
        this._pagination.sortDirection = 'asc';
      } else if (dateFilter === 'end_day') {
        sort = 'end';
        sortDirection = 'asc';
        this._pagination.sort = 'end';
        this._pagination.sortDirection = 'asc';
      }

      this._skipPagination = true;

      this._pagination.current_page = 0;

      this.fetchFirstPage(function() {
          delete that._skipPagination;
      }, true, sort, sortDirection);

      return this;
    },

    removeAllFilter () {

        const that = this;

        this.url = '/reservations?find=full';
        let sort = 'begin';
        let sortDirection = 'asc';
        this._pagination.sortDirection = 'asc';
        this._pagination.sort = 'begin';
        this._skipPagination = true;

        _.each(this._filterParams, function(value, key) {
            delete this._filterParams[key];
        },this);

        this._filterParams.begin_gte = moment().format('YYYY-MM-DD H:mm:ss');

        this._pagination.current_page = 0;

        this.fetchFirstPage(function() {
            delete that._skipPagination;
        }, true, sort, sortDirection);

        return this;
    },

    filterByQuery (val) {

        _.each(this._filterParams, function(value, key) {
            this._inactiveFilterParams[key] = value;
            delete this._filterParams[key];
        },this);
        return this.addFilter('order_nbr', val);
    },

    restoreInactiveFilter() {

        _.each(this._inactiveFilterParams, function(value,key) {
            if (key != 'order_nbr') {
                this.addFilter(key,value,false);
            }
            delete this._inactiveFilterParams[key];
        },this);

        this._filterParams.begin_gte = moment().format('YYYY-MM-DD H:mm:ss');
        this.removeFilter('order_nbr',false);
        this.setSort('begin','asc',true)
    }
});
